import { createAction, createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("LOAD_RISIKOVURDERING"),
	...createNetworkActions("ARCHIVE_RISIKOVURDERING"),
	...createNetworkActions("SAVE_RECOMMENDATION"),
	...createAction("RESET_RISIKOVURDERING"),
	...createAction("RISIKOVURDERING_COMPLETE"),
	...createAction("SET_PROFILE_SELECTION"),
	...createAction("IGNORE_ARCHIVED_RISIKOVURDERING"),
};
